module.exports = __webpack_public_path__ + "static/media/logoh.29fdc387.png";